import React from 'react'
import Typewriter from "typewriter-effect";


function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          '<h1 style="color: white;">Ooops</h1>',
          '<h1 style="color:white">Still</h1>',
          '<h1 style="color:white">Cooking!!</h1>',
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  )
}

export default Type;